export default __webpack_public_path__ + "static/media/curve-bottom.5adf9946.svg";